import { useEffect, useState, type FormEvent } from 'react';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
} from '@eureca/ui';

export interface AddItemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  placeholder: string;
  onAdd: (value: string) => void;
  'data-testid'?: string;
}

export function AddItemDialog({
  open,
  onOpenChange,
  title,
  placeholder,
  onAdd,
  'data-testid': testId,
}: AddItemDialogProps) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!open) setValue('');
  }, [open]);

  const canSubmit = value.trim().length > 0;

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!canSubmit) return;
    onAdd(value.trim());
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="gap-0 p-0 lg:w-full lg:max-w-[423px] lg:rounded-xl"
      >
        <DialogHeader className="gap-1.5 px-6 pt-6">
          <DialogTitle className="text-lg font-semibold leading-none tracking-[-0.025em] text-foreground">
            {title}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="px-6 pt-3 pb-8">
            <Input
              autoFocus
              value={value}
              onChange={(event) => setValue(event.target.value)}
              placeholder={placeholder}
              // EU-548 — espelha o cap dos writes (BFF/Core): nome custom
              // acima disso é rejeitado no PATCH com 400 genérico.
              maxLength={500}
              data-testid={testId ? `${testId}-input` : undefined}
            />
          </div>
          <DialogFooter className="px-6 pb-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Cancelar
              </Button>
            </DialogClose>
            <Button
              type="submit"
              disabled={!canSubmit}
              data-testid={testId ? `${testId}-submit` : undefined}
            >
              Salvar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
